
<script>
	import QRCode from "./QRJS.svelte"
    import AppBar from "./AppBar.svelte"
	import websocketStore from 'svelte-websocket-store';
	import { Base64 } from 'js-base64';
	import './decryptor.js'
	import { onDestroy, onMount, tick} from "svelte";
	import LinearProgress from '@smui/linear-progress';
	import Card, {Content, Media, MediaContent} from '@smui/card';
	import { createEventDispatcher } from 'svelte';
	import Password from "./Password.svelte";
  	import {Meta} from '@smui/list';
	import IconButton, {Icon} from '@smui/icon-button';

	const LIVE_SECONDS = 90;
	const ANIMATION_DURATION = 0.5;
	const dispatch = createEventDispatcher();

	function connectSocket() {
		inTransition = true;
		//let socket = websocketStore("ws://127.0.0.1:3030/ws");
		let socket = websocketStore("wss://passhome.app/ws");
		socketEnabled = true;
		let closeSocket = socket.subscribe(value => {
			if (value != undefined) {
				if (socketValue == undefined || value.session != socketValue.session) {
					elapsedSeconds = LIVE_SECONDS;
					valid = true;
					clearInterval(reconnectInterval);
//					console.log("Clear interval" + reconnectInterval);
					reconnectInterval = setInterval(() => {
						elapsedSeconds -= 0.1;
						if (elapsedSeconds <= ANIMATION_DURATION) {
							valid = false;
						}
						if (elapsedSeconds <= 0) {
							elapsedSeconds = 0;
							disconnectSocket();
							disconnect = connectSocket();
						}
					}, 100);
					//console.log("Set interval " + reconnectInterval);
				}
				socketValue = value;
				inTransition = false;
			}
		});
		return closeSocket;
	}

	function disconnectSocket() {
		socketEnabled = false;
		if (disconnect) {
			disconnect();
			disconnect = undefined;
		}
		if (reconnectInterval) {
			clearInterval(reconnectInterval);
			//console.log("Clear interval" + reconnectInterval);
		}
	}
    
	let elapsedSeconds;
	let disconnect ;
	let reconnectInterval;
	let key;
	let socketValue;
	let qrValue="";
	let qrWidth;
	let socketEnabled = true;
	let valueDirty = false;
	let valid = false; // The value may be used
	let inTransition = false; /// Shows that something is happening
	let lockPassword = false;
	$: {
		if (socketEnabled && socketValue && valid) {
			qrValue = socketValue.session + Base64.fromUint8Array(key);
			if (socketValue.hasOwnProperty("msg")) {
				lockPassword = true;
				dispatch('message', JSON.parse(window.decrypt(socketValue.msg, key)));
			}
		}
	}

	function clearValue() {
		valid = false;
		if (!socketEnabled) {
			disconnect = connectSocket();
		}
	}

	function valueChanged(e) {
		//console.log(e.target.value, socketEnabled);
		if (e.target.value == "" && !socketEnabled) {
			disconnect = connectSocket();
		} 
	}

	function inputChanged(i) {
		//console.log(i)
		if(socketEnabled) {
			disconnectSocket();
		}
		if (i.target.value == "") {
			if (socketValue == undefined) {
				valueChanged(i); // If user start typing before session is ackuired
			}
			valid=false;
		} else {
			valid = true;
		}
	}

	onMount(() => {
		lockPassword = false; // lockPassword to avoid field memorization dialog
		key = window.crypto.getRandomValues(new Uint8Array(32));
		disconnect = connectSocket();
	})

	onDestroy(() => {
		disconnectSocket();
	})
</script>
<AppBar title="PassHome Receiver"></AppBar>
<LinearProgress progress={socketEnabled ? elapsedSeconds / LIVE_SECONDS : 0} indeterminate={inTransition}/>
<Card >
<Content>
	<h2 class="mdc-typography--headline6" style="margin: 0;">Scan QR code with PassHome app</h2>
</Content>
<Media class="card-media-square" aspectRatio="square">
	<MediaContent>
		<div style="transition: {ANIMATION_DURATION}s ease all;" 
			class:clear={valid} 
			class:blurred={!valid} 
			class:transparent={socketEnabled && socketValue == undefined} bind:clientWidth={qrWidth}>
			<QRCode codeValue={qrValue} squareSize={qrWidth}/>
		</div>
	</MediaContent>
</Media>
<Content>
    <div class="mdc-list-item mdc-list-item--disabled" style="padding:0;">
		<Password bind:value={qrValue} label="QR Code {socketEnabled ? "session" : "custom"} value" visible={lockPassword} readOnly={lockPassword} autocomplete={false} bind:dirty={valueDirty} on:input={inputChanged} on:change={valueChanged} useNativeValidation={true}></Password>
		{#if !socketEnabled}
		<Meta>
			<IconButton  on:click={clearValue} title="clear">
				<Icon class="material-icons">clear</Icon>
			</IconButton>
		</Meta>
		{/if}
	</div>
</Content>
</Card>

<style>
	:global(.mdc-linear-progress) {
		min-height: 4px;
	}

	.clear {
		filter: blur(0px);
	}

	.transparent {
		opacity: 0;
	}

	.blurred {
		filter: blur(3px);
	}
</style>